import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import { SettingsAPI } from "../lib/api";

// Matches the backend's CompanyProfile defaults (backend/forge/company.py) so
// nothing ever renders blank / flashes before the first fetch resolves.
export const DEFAULT_COMPANY = {
  id: "default",
  company_name: "WXZA INC.",
  owner_name: "HAZOUME LOIC JERRY",
  contact_email: "jerryhazoume@gmail.com",
  address: null,
  payment_instructions: "Interac e-Transfer to jerryhazoume@gmail.com",
  invoice_number_prefix: "WXZA",
  document_number_prefix: "WXZA-DOC",
  default_currency: "CAD",
  default_jurisdiction: "Ontario, Canada",
  brand_footer: "Generated by WXZA Forge™",
  legal_disclaimer:
    "This document was generated with automated assistance and is provided for " +
    "informational purposes only. It is not legal advice and does not create a " +
    "solicitor-client relationship. Have it reviewed by a qualified lawyer in the " +
    "governing jurisdiction before signing or relying on it.",
};

const CompanyContext = createContext({
  company: DEFAULT_COMPANY,
  loading: true,
  refresh: async () => {},
  save: async () => {},
});

export const CompanyProvider = ({ children }) => {
  const [company, setCompany] = useState(DEFAULT_COMPANY);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const data = await SettingsAPI.getCompany();
      setCompany(data);
    } catch {
      // Backend unreachable / not yet deployed — keep the defaults so the
      // rest of the app still renders sensibly.
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const save = useCallback(async (patch) => {
    const updated = await SettingsAPI.updateCompany(patch);
    setCompany(updated);
    return updated;
  }, []);

  return (
    <CompanyContext.Provider value={{ company, loading, refresh, save }}>
      {children}
    </CompanyContext.Provider>
  );
};

export const useCompany = () => useContext(CompanyContext);
